/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_CategoryInputs */

const en_no_category = /** @type {(inputs: No_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No category`)
};

const de_no_category = /** @type {(inputs: No_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Kategorie`)
};

/**
* | output |
* | --- |
* | "No category" |
*
* @param {No_CategoryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_category = /** @type {((inputs?: No_CategoryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_CategoryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_category(inputs)
	return en_no_category(inputs)
});